<div class="row"   style="padding: 0px;">
  <div class="col-md-12" style="align-items: flex-end;">
    <button
      type="button" mat-button
      (click)="close()" style="background-color: transparent;float: right;
      background-repeat: no-repeat;
      border: none;
      color: red;
      cursor: pointer;
      overflow: hidden;
      outline: none;"
    > <i class="fa fa-times"></i></button>
  </div>
  <div class="row">
    <div class="col-md-2" style="padding:1px;">
      <mat-card style="padding: 0px;height: 100%;">
        <mat-card-header style="background-color:rgb(80, 76, 76); ">
            <b style="text-shadow: 2px 2px 4px rgba(0, 0, 0, 0.5);color: #FFFFFF;float: center;">Filter</b>
        </mat-card-header>
        <mat-card-content >
          <br>
          <div style="margin-left: 5%;">
            <input type="text" (keyup)="searchByInput()" id="inputsearch" placeholder="Search">
          </div>
          <div >
          <mat-card>
            <mat-card-header >
              <b style="text-shadow: 2px 2px 4px rgba(255, 255, 255, 0.5);color: #000000;"> Filter by Parameters</b>
            </mat-card-header>
            <mat-card-content style="overflow: auto;scroll-behavior: smooth;height:20vh;">
              <div id="checkboxContainer1" (click)="applyFilter()"></div>
            </mat-card-content>
          </mat-card>
          </div>
          <div>
            <mat-card>
              <mat-card-header>
                <b style="text-shadow: 2px 2px 4px rgba(255, 255, 255, 0.5);color: #000000;"> Filter by Site Name</b>
              </mat-card-header>
              <mat-card-content style="overflow: auto;scroll-behavior: smooth;height:42vh;">
                <div id="checkboxContainer" (click)="applyFilter()"></div>
              </mat-card-content>
            </mat-card>
          </div>
        </mat-card-content>
        </mat-card>
    </div>
    <div class="col-md-10" style="padding:0px">
      <mat-card style="padding: 0px;">
          <mat-card-header style="background-color:red; ">
              <b style="text-shadow: 2px 2px 4px rgba(0, 0, 0, 0.5);color: #FFFFFF;float: center;">Live Alerts</b>
          </mat-card-header>
          <mat-card-content style="overflow: auto;scroll-behavior: smooth;padding-right: 3px;padding-left: 3px;padding-bottom: 3px;">
              <ng-container  >
                  <div>
                      <table mat-table matTableExporter [dataSource]="dataSource" #exporter="matTableExporter" matSort
                        class="example-container mat-elevation-z8"  style="text-align: center;display: flex;width: 100%;">
                        <ng-container matColumnDef="date">
                          <th mat-header-cell *matHeaderCellDef
                            style="text-align: center;cursor: pointer;font-weight: bold;background-color: rgb(119, 226, 238);"> Date&nbsp;&nbsp;</th>
                          <td mat-cell *matCellDef="let element" >
                            {{element.date}} </td>
                        </ng-container>
                        <ng-container matColumnDef="time">
                          <th mat-header-cell *matHeaderCellDef
                            style="text-align: center;font-weight: bold;background-color: rgb(119, 226, 238);;"> Time&nbsp;&nbsp;</th>
                          <td mat-cell *matCellDef="let element"> {{element.time}} </td>
                        </ng-container>
                        <ng-container matColumnDef="sitename">
                          <th mat-header-cell *matHeaderCellDef
                            style="text-align: center;font-weight: bold;background-color:rgb(119, 226, 238);;"> SiteName&nbsp;&nbsp;</th>
                          <td mat-cell *matCellDef="let element"> {{element.sitename}} </td>
                        </ng-container>
                        <ng-container matColumnDef="parametername">
                          <th mat-header-cell *matHeaderCellDef
                            style="text-align: center;font-weight: bold;background-color: rgb(119, 226, 238);;"> Parameter Name&nbsp;&nbsp;</th>
                          <td mat-cell *matCellDef="let element"> {{element.parametername.replace('ap', '')}} </td>
                        </ng-container>
                        <ng-container matColumnDef="actual">
                          <th mat-header-cell *matHeaderCellDef
                            style="text-align: center;font-weight: bold;background-color: rgb(119, 226, 238);;"> Actual Value&nbsp;&nbsp;</th>
                          <td mat-cell *matCellDef="let element">   {{ element.actual == 4 && element.parametername == 'apOillevel'  ? 'LOW' : element.actual == 5 && element.parametername == 'apOillevel' ? 'MEDIUM' : element.actual == 6 && element.parametername == 'apOillevel' ? 'HIGH':element.actual }}</td>
                        </ng-container>
                        <ng-container matColumnDef="threshold">
                          <th mat-header-cell *matHeaderCellDef style="text-align: center;font-weight: bold;background-color: rgb(119, 226, 238);;"> Threshold Value&nbsp;&nbsp;</th>
                          <td mat-cell   *matCellDef="let element" >{{ element.threshold == 5 && element.parametername ? 'MEDIUM':element.threshold}} </td>
                        </ng-container>
                        <ng-container matColumnDef="transformer">
                          <th mat-header-cell *matHeaderCellDef style="text-align: center;font-weight: bold;background-color: rgb(119, 226, 238);;"> Transformer Id&nbsp;&nbsp;</th>
                          <td mat-cell   *matCellDef="let element" >{{element.transformer}} </td>
                        </ng-container>
                        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
                        <tr class="scrolling-text" mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
                      </table>
                      <mat-paginator [pageSizeOptions]="[10, 15, 20]" showFirstLastButtons></mat-paginator>
                    </div>
              </ng-container>
          </mat-card-content>
          </mat-card>
  </div>
</div>